export default function LiveDisplayInfo() {
  return (
    <div style={{ padding: 16 }}>
      <h3>About Live Display</h3>
      <p>
        Live Display runs your pre-service loop, then takes over every connected
        screen with the active service slideshow when you start service.
      </p>
    </div>
  );
}
